var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1164 1.88378C13.7879 1.55535 13.3225 1.42681 12.8729 1.54069L1.98781 4.28164C1.43016 4.4222 1.03433 4.90224 1.00203 5.47636C0.970392 6.05048 1.31053 6.57171 1.84906 6.7731L7.21862 8.78154L9.22709 14.1508C9.41957 14.6661 9.90505 15 10.4495 15C10.4742 15 10.4993 14.9993 10.524 14.9979C11.0985 14.9659 11.5783 14.5697 11.7187 14.0121L14.4595 3.12728C14.5729 2.67706 14.4447 2.21221 14.1164 1.88378ZM11.8575 3.18859L7.57324 7.47275L2.45153 5.5571L11.8575 3.18859ZM10.4433 13.5487L8.52774 8.42722L12.8116 4.14337L10.4433 13.5487Z",
    fill: "#969696"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.8e571ef8ce817eb1745c8099081e6ee9.svg";
export { ForwardRef as ReactComponent };